// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"20ad85eb","254":"c34b8818","425":"2182d3e5","440":"e2948873","490":"56ada7f7","531":"42ae44da","563":"94e27ad3","638":"ddec7f9c","694":"91f0bf6f","713":"f0c3fefc","821":"024491d7","936":"a320b818","991":"be1257cf"}[chunkId] + ".chunk.js";
};